import React from "react";
import "focus-visible/dist/focus-visible";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";

export default function ThemeProvider({ children }) {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
}
